module.exports = __webpack_public_path__ + "static/img/timg1.8a86727.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sliderVertify/images/timg1.png
// module id = Ccmg
// module chunks = 92